import { render, staticRenderFns } from "./teacher-login.vue?vue&type=template&id=789db9d2&lang=pug&"
import script from "./teacher-login.vue?vue&type=script&lang=js&"
export * from "./teacher-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports